import ZJApp from '../app'
import views from './src/views'

const utils = ZJApp.ZJUtils;

const getView = function(uri) {
    const that = this;
    let path = uri.path;
    return new Promise(function (resolve, reject) {
        let arr = path.split('/');
        let controller = arr.length >= 3 ? arr[1] : 'ui';
        let action = (arr.length >= 3 ? arr[2] : arr[1]) || 'index';
        let view = null;
        utils.each(views, x=>{
            if (typeof x === 'object' && x.controller && x.action &&
                x.controller.toLowerCase() == controller.toLowerCase() &&
                x.action.toLowerCase() == action.toLowerCase()) {
                view = x;
                return false;
            }
        });
        if (view) {
            resolve(view);
        }
        else {
            reject('在插件 ' + that.name + ' 中未找到路径 ' + path);
        }
    });
};

const onLogin = function() {
    console.debug('demo - onlogin', ZJApp, ZJApp.notify);
}

const onLogout = function() {
    console.debug('demo - onlogout');
}

const install = function() {
    ZJApp.on('login', onLogin);
    ZJApp.on('logout', onLogout);

    // 安装插件时，可能已经登录完成，
    // 因此手动检查一次。
    if (ZJApp.user.isLogin) {
        onLogin();
    }
};

// 每一个插件必须具有 name, getView 属性。
export default {
    name: 'Demo',
    displayName: '示例',
    getView,
    install
}
